import DocumentIcon from '@icons/ai-agents/document-icon';
import ScriptIcon from '@icons/ai-agents/script-icon';

export const navbarLinks = [
  {
    key: '1',
    label: 'Script',
    icon: ScriptIcon,
    path: 'script'
  },
  {
    key: '2',
    label: 'Natijalar',
    icon: DocumentIcon,
    path: 'result'
  }
];
